import React, { Component } from 'react';

class MySubmit extends Component {
  static defaultProps = {
    className: "",
    children: null,
    type: "submit",
    onClick: null
  };

  render() {
    const { className, text, type, onClick, children, style = {} } = this.props;
    return (

      <button style={style} type={type} onClick={onClick !== null ? onClick : () => {
      }}
              className={"btn btn-secondary btn-block form-control form-control-lg " + className}>
        {children !== null ? children : text}
      </button>
    );
  }
}

export default MySubmit;
